import { Flex } from '../../component-library';
import { useEffect, useState } from 'react';
import { useReceiveMessage } from '../../context/messageContext';
import { LandoltC } from '../';

const PatientStimulusPoint = ({ logmarSize, stimulusCoordinates, updateTestProgressData, patientInputMethod }) => {
  const [currentLandoltCQuadrant, setCurrentLandoltCQuadrant] = useState(null);

  const messageFromOptician = useReceiveMessage();

  useEffect(() => {
    const potentialOpenings = [1, 2, 3, 4];
    const randomIndex = Math.floor(Math.random() * potentialOpenings.length);
    setCurrentLandoltCQuadrant(potentialOpenings[randomIndex]);
  }, []);

  useEffect(() => {
    if (currentLandoltCQuadrant)
      updateTestProgressData({
        type: 'updateCurrentLandoltCQuadrant',
        payload: currentLandoltCQuadrant,
      });
  }, [currentLandoltCQuadrant, updateTestProgressData]);

  useEffect(() => {
    if (patientInputMethod === 'opticianControl' && messageFromOptician.type === 'opticianQuadrantResponse') {
      updateTestProgressData({ type: 'updatePatientQuadrantResponse', payload: +messageFromOptician.content });
    }
  }, [updateTestProgressData, patientInputMethod, messageFromOptician]);

  useEffect(() => {
    const handleKeyboardInput = (e) => {
      if (+e.key > 0 && +e.key < 5) {
        updateTestProgressData({ type: 'updatePatientQuadrantResponse', payload: +e.key });
        return () => {
          window.removeEventListener('keydown', handleKeyboardInput);
        };
      }
    };

    window.addEventListener('keydown', handleKeyboardInput);

    return () => window.removeEventListener('keydown', handleKeyboardInput);
  });

  return (
    <Flex
      style={{
        position: 'absolute',
        top: `${stimulusCoordinates?.y || 0}px`,
        left: `${stimulusCoordinates?.x || 0}px`,
      }}
    >
      <LandoltC openingQuadrant={currentLandoltCQuadrant} logmarSize={logmarSize} />
    </Flex>
  );
};

export default PatientStimulusPoint;
